<template>
  <cTable
    ref="table"
    :fields="fields"
    :header="header"
    :footer="footer"
    :methods="methods"
    :modals="modals"
    :config="config"
  >
    <template #showDetails>
      <div style="height: 650px; overflow: auto">
        <Tag
          type="border"
          v-for="item in list"
          :key="item"
          size="large"
          style="height: 32px; line-height: 32px"
        >
          {{ item }}
        </Tag>
      </div>
    </template>
  </cTable>
</template>

<script>
import {
  getBackWarehouse,
  getBackWarehouseAwb,
} from "@/api/analysis/back_warehouse";
import { getAllClient } from "@/api/user/client";
import { getUser } from "@/api/user/internal";
import { getSelectType } from "@/api/public";
import { getCountry } from "@/api/system/country";

import copyClick from "@/utils/copyClick";
import cTable from "@/base/common/index";

export default {
  name: "back_warehouse",
  components: {
    cTable,
  },
  methods: {
    getModalList(row, field, text) {
			let searchData = this.$refs['table'].$refs['header'].handleFilterData()
			console.log();
      let data = {
				...searchData,
        day: row.report_dates,
        dateType: row.dateType,
        backHours: field.key,
      };
      getBackWarehouseAwb(data).then((res) => {
        this.list = Array.from(new Set(res.data.payload));
      });
      let title = text ? field.name + text : field.name;
      this.$refs["table"].getModal("details").open({}, function () {
        this.setTitle(title);
      });
    },
  },
  data() {
    return {
      list: [],
      methods: {
        list: getBackWarehouse,
        getAllClient,
        getSelectType,
        getCountry,
        getUser,
        getBackWarehouseAwb,
      },
      config: {
        height: 630,
        merge: true,
      },
      footer: { show: () => true },
      modals: {
        details: {
          methods: {
            cancel: () => {
              this.list = [];
            },
          },
          contentSlot: "showDetails",
          config: {
            modalBind: {
              width: 850,
              draggable: true,
            },
            modalContentBind: {
              style: {
                height: "650px",
              },
            },
          },
          header: {
            show: () => true,
            btns: [
              {
                name: () => this.$t("all") + this.$t("copy"),
                key: "copy",
                fnName: "copy",
                bind: {
                  type: "primary",
                  style: {
                    margin: "0 10px",
                  },
                },
              },
            ],
            methods: {
              copy: () => {
                let data = this.list.join("\r\n");
                copyClick.copyToClipboard(data, this);
              },
            },
          },
          footer: {
            show: () => false,
          },
        },
      },
      header: {
        config: {
          custom: false,
        },
        searchs: [
          {
            key: "dateType",
            placeholder() {
              return this.$t("select") + this.$t("date") + this.$t("type");
            },
            clearable: false,
            component: "Select",
            options: [],
            config: {
              label({ row, field }) {
                return this.$t(row.label);
              },
            },
            methods: {
              async list({ field, searchForm }) {
                let res = (await getSelectType(["ANALYZE_DATE_SELECT_TYPE"]))
                  .data.payload["ANALYZE_DATE_SELECT_TYPE"];
                field.options = res;
                searchForm[field.key] = res[0].value;
                this.$forceUpdate();
              },
            },
          },
          {
            key: "startTime",
            component: "DatePicker",
            placeholder() {
              return this.$t("select") + this.$t("start") + this.$t("date");
            },
            // default() {
            //   return this.$page.format.dateFormat(
            //     new Date().setDate(1),
            //     "yyyy-MM-dd"
            //   );
            // },
            bind: {
              clearable: true,
              type: "date",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "150px",
              },
            },
            methods: {
              format({ searchForm, value, newFormData }) {
                return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
              },
            },
          },
          {
            key: "endTime",
            component: "DatePicker",
            placeholder() {
              return this.$t("select") + this.$t("end") + this.$t("date");
            },
            // default() {
            //   return this.$page.format.dateFormat(new Date(), "yyyy-MM-dd");
            // },
            bind: {
              clearable: true,
              type: "date",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "150px",
              },
            },
            methods: {
              format({ searchForm, value, newFormData }) {
                return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
              },
            },
          },
          {
            key: "client_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            clearable: true,
            options: [],
            methods: {
              async list({ field }) {
                field.options = (
                  await this.$page.handleRequestMethods("getAllClient")
                ).payload.rows;
                this.$forceUpdate();
              },
            },
            config: { label: "account", value: "id" },
            bind: {
              style: "width:150px",
            },
          },
          {
            key: "salesman_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("salesman");
            },
            clearable: true,
            options: [],
            methods: {
              async list({ field }) {
                field.options = (
                  await this.$page.handleRequestMethods("getUser", {
                    standard: "Salesman",
                  })
                ).payload.rows;
                this.$forceUpdate();
              },
            },
            config: { label: "account", value: "id" },
            bind: {
              style: "width:150px",
            },
          },
          {
            key: "to_country",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("target_country");
            },
            clearable: true,
            options: [],
            methods: {
              async list({ field }) {
                field.options = (
                  await this.$page.handleRequestMethods("getCountry", {
                    allow_arrive: 1,
                  })
                ).payload.rows;
                this.$forceUpdate();
              },
            },
            config: { label: "code", value: "code" },
            bind: {
              style: "width:150px",
            },
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            bind: {
              style: "width:140px",
              type: "textarea",
              rows: 1,
            },
            component: "Input",
          },
        ],
        btns: {
          list: [
            {
              name: this.$t("export"),
              type: "export",
              fnName: "export",

              bind: {
                icon: "md-arrow-down",
                type: "primary",
              },
            },
          ],
          methods: {
            export() {
              this.exportExc({ data: this.list });
            },
          },
        },
      },
      fields: [
        {
          name: () => this.$t("back_warehouse") + this.$t("list"),
          key: "refundSummary",
          children: [
            {
              name: () => this.$t("outTicket") + this.$t("time"),
              key: "report_dates",
              align: "left",
              minWidth: 120,
            },
            {
              name: this.$t("outTicket") + this.$t("noofpieces"),
              key: "send_delivery_count",
              align: "left",
              minWidth: 80,
              component: "Button",
              bind: {
                type: "primary",
                size: "small",
              },
              disabled({ row, field }) {
                return row[field.key] == 0;
              },
              methods: {
                click: ({ row, field }) => {
                  this.getModalList(row, field);
                },
              },
            },
            {
              name: this.$t("back_warehouse_num"),
              children: [
                {
                  name: this.$t("one_hours"),
                  key: "back_hours_24",
                  align: "left",
                  minWidth: 100,
                  component: "Button",
                  bind: {
                    type: "primary",
                    size: "small",
                  },
                  disabled({ row, field }) {
                    return row[field.key] == 0;
                  },
                  methods: {
                    click: ({ row, field }) => {
                      this.getModalList(
                        row,
                        field,
                        this.$t("back_warehouse_num")
                      );
                    },
                  },
                },
                {
                  name: this.$t("two_hours"),
                  key: "back_hours_24_48",
                  align: "left",
                  minWidth: 100,
                  component: "Button",
                  bind: {
                    type: "primary",
                    size: "small",
                  },
                  disabled({ row, field }) {
                    return row[field.key] == 0;
                  },
                  methods: {
                    click: ({ row, field }) => {
                      this.getModalList(
                        row,
                        field,
                        this.$t("back_warehouse_num")
                      );
                    },
                  },
                },
                {
                  name: this.$t("three_hours"),
                  key: "back_hours_48_72",
                  align: "left",
                  minWidth: 100,
                  component: "Button",
                  bind: {
                    type: "primary",
                    size: "small",
                  },
                  disabled({ row, field }) {
                    return row[field.key] == 0;
                  },
                  methods: {
                    click: ({ row, field }) => {
                      this.getModalList(
                        row,
                        field,
                        this.$t("back_warehouse_num")
                      );
                    },
                  },
                },
                {
                  name: this.$t("four_hours"),
                  key: "back_hours_72_above",
                  align: "left",
                  minWidth: 100,
                  component: "Button",
                  bind: {
                    type: "primary",
                    size: "small",
                  },
                  disabled({ row, field }) {
                    return row[field.key] == 0;
                  },
                  methods: {
                    click: ({ row, field }) => {
                      this.getModalList(
                        row,
                        field,
                        this.$t("back_warehouse_num")
                      );
                    },
                  },
                },
              ],
            },
            {
              name: () => this.$t("Not") + this.$t("back_warehouse_num"),
              key: "not_back",
              align: "left",
              minWidth: 100,
              component: "Button",
              bind: {
                type: "primary",
                size: "small",
              },
              disabled({ row, field }) {
                return row[field.key] == 0;
              },
              methods: {
                click: ({ row, field }) => {
                  this.getModalList(row, field);
                },
              },
            },
            {
              name: () => this.$t("target_country"),
              key: "to_country",
              align: "left",
              minWidth: 100,
            },
            {
              name: () => this.$t("warehouse_return_rate"),
              children: [
                {
                  name: () => this.$t("one_hours"),
                  key: "back_hours_24_rate",
                  align: "left",
                  minWidth: 100,
                },
                {
                  name: () => this.$t("two_hours"),
                  key: "back_hours_24_48_rate",
                  align: "left",
                  minWidth: 100,
                },
                {
                  name: () => this.$t("three_hours"),
                  key: "back_hours_48_72_rate",
                  align: "left",
                  minWidth: 100,
                },
                {
                  name: () => this.$t("four_hours"),
                  key: "back_hours_72_above_rate",
                  align: "left",
                  minWidth: 100,
                },
                {
                  name: () =>
                    this.$t("gather") + this.$t("warehouse_return_rate"),
                  key: "send_delivery_rate",
                  align: "left",
                  minWidth: 100,
                },
              ],
            },
            {
              name: () => this.$t("Not") + this.$t("warehouse_return_rate"),
              key: "not_back_rate",
              align: "left",
              minWidth: 100,
            },
          ],
        },
      ],
    };
  },
  mounted() {},
};
</script>
